import * as React from "react";
//import { COLORS } from "../../constants/colors";

// Define button variants
const buttonStyles = {
    primary: "bg-[#3B0764] text-white hover:bg-[#4B1B89]",
    secondary: "bg-white text-[#3B0764] border border-[#3B0764] hover:bg-[#4B1B89] hover:text-white",
    "purple-outlined": "text-[#2D0A4D] font-semibold border-2 border-[#2D0A4D] rounded-full hover:bg-[#2D0A4D] hover:text-white transition-colors",
    "white-outlined": "text-white font-semibold border-2 border-white rounded-full hover:bg-white hover:text-[#2D0A4D] transition-colors",
};

// Export a simple Button component
const Button = React.forwardRef(({ variant = "primary", ...props }, ref) => (
    <button
        ref={ref}
        className={`px-6 py-3 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 flex items-center gap-2 ${buttonStyles[variant]}`}
        {...props}
    />
));

Button.displayName = "Button";

export { Button };
